/**
 * About the 'oxg' Prefix
 * 
 * All global variables and functions, that are created within the oxg dev environment are prefixed. This
 * decreases the probability of collisions with other scripts, which can be hard to troubleshoot and debug.
 * 
 * Generally speaking it is still possible for collisions to occur, when working with third party code. But this
 * would require such code to use the same prefix, the chances of which are low.
 * 
 * There is also a oxg object, which holds general data, which needs to be globally accessible.
 */

/* ANCHOR ---- oxg object -------------------------- */

window.oxg = {
    reg: new Array,
    computedStyles: null,
    mouse: {
        x: null,
        y: null,
        xPrev: null,
        yPrev: null,
        xDirection: null,
        yDirection: null,
    },
    scrollbar: {
        w: window.innerWidth - document.documentElement.clientWidth,
    },
    page: {
        h: null,
        w: null,
        isScrolledY: null,
        scrollX: null,
        scrollY: null,
        scrollYPercent: null,
    },
    nav: {
        isHidden: null,
        isDocked: null,
        isCompact: null,
    },
    win: {
        w: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        wClean: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - (window.innerWidth - document.documentElement.clientWidth), //width without scrollbar width
        h: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        wPrev: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        hPrev: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        wGrow: false,
        hGrow: false,
        wShrink: false,
        hShrink: false,
    },
    html: null,
    body: null,
    hoverTooltip: {
        pixel: null,
        container: null,
        text: null,
    },
    bp: {
        xs: 360,
        s: 478,
        ms: 767,
        m: 991,
        l: 1279,
        xl: 1552,
        xxl: 1920,
        xxxl: 2320,
        wpAdminBar: 782,        
    },
    wpAdminBarHeight: 32,
    wpAdminBarHeightS: 46,
}

function resizeInit() {
    window.oxg.body = document.body
    window.oxg.html = document.documentElement
    window.oxg.page.h = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight )
    window.oxg.page.w = document.documentElement.scrollWidth
    updateOxg()
    window.addEventListener('resize', ()=> {
        var doUpdate = () => { updateOxg() }
        requestAnimationFrame(doUpdate)
    })
}

function scrollInit() {
    var doUpdate = ()=> {
        window.oxg.page.scrollY = window.scrollY
        window.oxg.page.h = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight )
        window.oxg.page.w = document.documentElement.scrollWidth
        window.oxg.page.scrollYPercent = Math.round(window.scrollY/(window.oxg.page.h - window.oxg.win.h)*100)
        window.oxg.page.isScrolledY = window.scrollY > 0 ? true : false
        if( window.oxg.page.isScrolledY ) {
            document.body.classList.add('is-scrolled')
            document.body.setAttribute('data-scroll', window.oxg.page.scrollY)
            document.body.setAttribute('data-scroll-percent', window.oxg.page.scrollYPercent)
        } else {
            document.body.classList.remove('is-scrolled')
            document.body.setAttribute('data-scroll', 0)
            document.body.setAttribute('data-scroll-percent', 0)
        }
    }
    window.addEventListener('scroll', ()=> {
        requestAnimationFrame(doUpdate)
    })
}

function updateOxg() {
    //computed styles
    //window.oxg.computedStyles = getComputedStyle(document.documentElement)
    //previous width and height
    window.oxg.win.wPrev = window.oxg.win.w
    window.oxg.win.hPrev = window.oxg.win.h
    //scrollbar width
    window.oxg.scrollbar.w = window.innerWidth - document.documentElement.clientWidth
    //width and height
    window.oxg.win.w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    window.oxg.win.h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    window.oxg.win.wClean = window.oxg.win.w - window.oxg.scrollbar.w
    //pageHeight
    window.oxg.page.h = Math.max( window.oxg.body.scrollHeight, window.oxg.body.offsetHeight, window.oxg.html.clientHeight, window.oxg.html.scrollHeight, window.oxg.html.offsetHeight )
    window.oxg.page.scrollY = window.scrollY
    window.oxg.page.scrollYPercent = Math.round(window.scrollY/(window.oxg.page.h-window.oxg.win.h)*100)
    //grow or shrink
    //window.oxg.win.wPrev < window.oxg.win.w ? window.oxg.win.wGrow = true : window.oxg.win.wGrow = false
    //window.oxg.win.hPrev < window.oxg.win.h ? window.oxg.win.hGrow = true : window.oxg.win.hGrow = false
    //window.oxg.win.wPrev > window.oxg.win.w ? window.oxg.win.wShrink = true : window.oxg.win.wShrink = false
    //window.oxg.win.hPrev > window.oxg.win.h ? window.oxg.win.hShrink = true : window.oxg.win.hShrink = false
    //clean width
    //console.log('oxg', window.oxg)
}

document.addEventListener('DOMContentLoaded', () => {
    resizeInit()
    scrollInit()
});